<template>
    <main class="track-event-list">
        <pendo-table
            csv-download
            resizable
            title="Track Events"
            :max-height="600"
            :data="trackEventMockedData"
            :filters="filters"
            row-key="name"
            :default-sort="defaultSort"
            :columns="mockedColumns">
            <template #empty>
                <div class="track-events-list--table--empty">
                    <pendo-icon
                        type="alert-circle"
                        class="empty-icon"
                        stroke="#9a9ca5"
                        size="24" />
                    <span class="empty-text">
                        No data found.
                    </span>
                </div>
            </template>
        </pendo-table>
    </main>
</template>

<script>
import { PendoIcon, PendoTable, PendoLoading } from '@pendo/components';
import { trackEventMockedData, mockedColumns } from './mockedTrackEvents';

export default {
    name: 'AnalyticsTrackEventList',
    components: {
        PendoIcon,
        PendoTable
    },
    directives: {
        PendoLoading
    },
    props: {
        searchString: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            trackEventList: [],
            unsubscribeFilterBarListener: null,
            defaultSort: {
                prop: 'name',
                order: 'ascending'
            },
            trackEventMockedData,
            mockedColumns
        };
    },
    computed: {
        filters () {
            return [
                {
                    prop: ['name', 'app.displayName'],
                    value: this.searchString
                }
            ];
        }
    }
};
</script>

<style lang="scss">
.track-event-list {
    &--table {
        &--empty {
            display: flex;
            align-items: center;
            justify-content: center;

            .pendo-icon {
                margin-right: 0.5em;
                display: flex;
            }

            .empty-text {
                color: $gray-primary;
            }
        }
    }

    .pendo-table__header {
        .pendo-table__column {
            text-transform: capitalize;
        }
    }
}
</style>
